<template>
    <div class="mt-4">
        <div class="disclaimer-panel">
            <div class="d-flex">
                <v-textarea
                    v-model="model.text"
                    class="disclaimer-field"
                    color="black"
                    solo
                    auto-grow
                    full-width
                    rows="2"
                    row-height="10"
                    dense
                    filled
                    :value="model.text"
                    @change="setDisclaimerAttribute('text')"
                />
            </div>
            <div class="d-flex">
                <v-spacer/>

                <div class="align-self-baseline">
                    <div class="font-size-select">
                        <v-select
                            class="pa-0"
                            v-model="model.fontsize"
                            solo
                            :height="30"
                            :items="fontSizeItems"
                            @input="setDisclaimerAttribute('fontsize')"
                        />
                    </div>
                </div>

                <v-spacer/>

                <div class="align-self-baseline">
                    <v-menu
                        offset-y
                        :close-on-content-click="false"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="color-picker-cta"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                :elevation="0"
                                :style="{'background-color': model.color }"
                            />
                        </template>
                        <v-list class="py-0">
                            <v-list-item class="px-0">
                                <v-list-item-content class="py-0">
                                    <v-color-picker
                                        v-model="model.color"
                                        dot-size="25"
                                        hide-inputs
                                        swatches-max-height="200"
                                        @input="setDisclaimerAttribute('color')"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>

                <v-spacer/>
            </div>
        </div>
        
        <div class="d-flex pt-2 justify-end">
            <v-btn
                class="save-disclaimer-cta px-0 dark-text text-none right-center"
                :class="{ 'green-text text-darken-1': isSettingsUpdated }"
                color="transparent"
                :ripple="false"
                :elevation="0"
                @click.prevent="saveDisclaimerSettings"
            >
                <v-icon
                    v-show="isSettingsUpdated"
                    :class="{ 'green-text text-darken-1': isSettingsUpdated }"
                    left
                >
                    mdi-checkbox-marked-circle
                </v-icon>
                {{ $t('habiteoStudio.saveByDefault') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'DisclaimerPanel',
        props: {
            selectedValues: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                fontSizeItems: [
                    {
                        text: this.$t('habiteoStudio.fontSize.small'),
                        value: 12
                    },
                    {
                        text: this.$t('habiteoStudio.fontSize.medium'),
                        value: 16
                    },
                    {
                        text: this.$t('habiteoStudio.fontSize.tall'),
                        value: 24
                    }
                ],
                model: {},
                isSettingsUpdated: false 
            }
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
        },
        created() {
            this.model = this.$props.selectedValues;
        },
        methods: {
            setDisclaimerAttribute(type) {
                var value = this.model[type] || '';
                this.$emit(`set-${type}`, value);
                this.isSettingsUpdated = false;
            },
            saveDisclaimerSettings() {
                if (this.isLocalstorageAvailable) {
                    localStorage.setItem('myHabiteo-studio-disclaimer', JSON.stringify(this.model));
                    this.isSettingsUpdated = true;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/DisclaimerPanel.vue